import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <IndexSection />
        <FAQSection />
        <AboutSection />
        <AppSection />
        <FeaturesSection />
        <CardsSection />
        <RankingSection />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
        <MediaSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}